import { render, staticRenderFns } from "./NoRoom.vue?vue&type=template&id=2696f4ef&"
import script from "./NoRoom.vue?vue&type=script&lang=js&"
export * from "./NoRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports